import { Cookies } from 'react-cookie';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON } from '../../helpers/api';
import {
  loginUserSuccess,
  loginUserFailed,
  logoutUser,
  registerUserSuccess,
  registerUserFailed,
  forgotPasswordSuccess,
  forgotPasswordFailed,
  changePasswordSuccess,
  changePasswordFailed,
  daily3wordsSuccess,
  daily3wordsFailed,
} from './actions';
import {
  LOGIN_USER,
  LOGOUT_USER,
  REGISTER_USER,
  FORGOT_PASSWORD_REQUEST,
  CHANGE_PASSWORD,
  DAILY_3WORDS_REQUEST,
} from './constants';

const SERVER_URL = process.env.REACT_APP_KDM_API_ENDPOINT;

const setSession = (user) => {
  let cookies = new Cookies();
  if (user) {
    cookies.set('user', JSON.stringify(user), { path: '/' });
  } else {
    cookies.remove('user', { path: '/' });
  }
};

function* login({ payload: { username, password } }) {
  const options = {
    body: JSON.stringify({ user: username, pass: password }),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/login`, options);
    if (response.error) {
      var error = new Error(response.error_description);
      error.status = 401;
      throw error;
    }
    setSession(response);
    yield put(loginUserSuccess(response));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Invalid credentials';
        break;
      default:
        message = error.message || error.toString();
    }
    yield put(loginUserFailed(message));
    setSession(null);
  }
}

function* logout({ payload: { history } }) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/logout`, options);
    if (response.error) {
      var error = new Error(response.error_description);
      error.status = 401;
      throw error;
    }
    setSession(null);
    yield call(() => {
      history.push('/account/login');
    });
  } catch (error) {
    //console.log('Logout error:', error);
    /**
     * {
    "0": "Y",
    "1": "o",
    "2": "u",
    "3": " ",
    "4": "h",
    "5": "a",
    "6": "v",
    "7": "e",
    "8": " ",
    "9": "b",
    "10": "e",
    "11": "e",
    "12": "n",
    "13": " ",
    "14": "l",
    "15": "o",
    "16": "g",
    "17": "g",
    "18": "e",
    "19": "d",
    "20": " ",
    "21": "o",
    "22": "u",
    "23": "t",
    "24": "!",
    "status": 302
    }
     */
    let message;
    switch (error.status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Invalid credentials';
        break;
      default:
        message = error;
    }
    setSession(null);
    yield call(() => {
      history.push('/account/login');
    });
  }
}

function* register({ payload: { fullname, email, password } }) {
  const options = {
    body: JSON.stringify({ fullname, email, password }),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/register`, options);
    yield put(registerUserSuccess(response));
  } catch (error) {
    let message;
    switch (error.status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Invalid credentials';
        break;
      default:
        message = error;
    }
    yield put(registerUserFailed(message));
  }
}

function* forgotPassword({ payload: { email } }) {
  const options = {
    body: JSON.stringify({ email }),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/resetpassword`, options);
    yield put(forgotPasswordSuccess(response.message));
  } catch (error) {
    let message;
    if (error.status) {
      switch (error.status) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message =
            error.error && error.error.description
              ? error.error.description
              : 'Invalid credentials';
          break;
        default:
          message = error.message || error.toString();
      }
    } else {
      message = error.message || 'An unknown error occurred';
    }
    yield put(forgotPasswordFailed(message));
  }
}

function* changePassword({ payload: { email, passcode, password } }) {
  const options = {
    body: JSON.stringify({ email, passcode, password }),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/checkresetpassword`, options);
    yield put(changePasswordSuccess(response));
  } catch (error) {
    let message;
    if (error && error.statusCode) {
      switch (error.statusCode) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 405:
          message = 'StatusCode: 405 Error';
          break;
        case 401:
          message = error.description ? error.description : "The client is not authenticated or authorized.";
          break;
        default:
          message = 'An unknown error occurred';
          break;
      }
    } else {
      message = 'An unknown error occurred';
    }
    yield put(changePasswordFailed(message));
  }
}

// New saga for Daily3Words
function* daily3words() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = yield call(fetchJSON, `${SERVER_URL}/User/daily3words`, options);
    // Expecting response: { Daily3Words: "Lyre Sane Monsoon" }
    yield put(daily3wordsSuccess(response));
  } catch (error) {
    let message;
    if (error.status) {
      switch (error.status) {
        case 500:
          message = 'Internal Server Error';
          break;
        case 401:
          message = 'Unauthorized: wrong authorization';
          break;
        default:
          message = error.message || error.toString();
      }
    } else {
      message = error.message || 'An unknown error occurred';
    }
    yield put(daily3wordsFailed(message));
  }
}

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, login);
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, register);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD_REQUEST, forgotPassword);
}

export function* watchChangePassword() {
  yield takeEvery(CHANGE_PASSWORD, changePassword);
}

// Watcher for Daily3Words
export function* watchDaily3words() {
  yield takeEvery(DAILY_3WORDS_REQUEST, daily3words);
}

export function* authSaga() {
  yield all([
    call(watchLoginUser),
    call(watchLogoutUser),
    call(watchRegisterUser),
    call(watchForgotPassword),
    call(watchChangePassword),
    call(watchDaily3words),
  ]);
}

export default authSaga;
